<template>
<div class="order" v-if="order">
  <breadcrumb :items="[{ text: (isA('client') ? 'Meus pedidos' : 'Pedidos'), to: '/pedidos' }, { text: 'Pedido #' + order.code, active: true }]" />
  <div class="row">
    <div class="col-md-6">
      <table>
        <tbody>
          <tr v-if="order.name">
            <td>Nome:</td>
            <th class="text-left">{{order.name}}</th>
          </tr>
          <tr v-if="order.cnpj">
            <td>CNPJ:</td>
            <th class="text-left">{{order.cnpj | cpfOrCnpj}}</th>
          </tr>
          <tr v-if="order.email">
            <td>Email:</td>
            <th class="text-left">{{order.email}}</th>
          </tr>
          <tr v-if="order.phone">
            <td>Telefone:</td>
            <th class="text-left">{{order.phone}}</th>
          </tr>
          <tr v-if="order.address">
            <td>Endereço:</td>
            <th class="text-left">{{order.address.description}}</th>
          </tr>
          <tr v-if="order.main_activity">
            <td>Atividade principal:</td>
            <th class="text-left">{{order.main_activity}}</th>
          </tr>
          <tr v-if="order.state_registration">
            <td>Inscrição estadual:</td>
            <th class="text-left">{{order.state_registration}}</th>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-md-6">
      <documents-upload :form="form" :cb="saveDocuments" field="attachments" url="uploads/documents" :multiple="true" />
    </div>
    <div class="col-md-12">
      <b-form-group label="Adicione outras redes relacionadas a esse pedido" v-if="isLink">
        <form-entities-select type="organizations" label="Selecione o usuário" :form="order" :onChange="saveRelatedOrganizations" field="relatedOrganizations" />
      </b-form-group>
    </div>
  </div>
  <table class="table b-table b-table-stacked-lg">
    <thead>
      <tr>
        <th></th>
        <th>Oferta</th>
        <th>Origem</th>
        <th>Fornecedor</th>
        <th>NF</th>
        <th>Valor</th>
        <th>Qtd</th>
        <th>Total</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in order.items" :key="index">
        <td>
          <product-image :product="item.offer.product" :product_variation="item.offer.product_variation" css_class="thumb" />
        </td>
        <td>
          <router-link :to="'/oferta/'+item.offer._id">{{item.offer.product_variation.name}}</router-link>
        </td>
        <td>
          <small v-if="item.offer.address">{{item.offer.address.description}}</small>
        </td>
        <td>
          <div v-if="item.offer.supplier">
            Fornecedor:
            <supplier-info :supplier="item.offer.supplier" />
          </div>
          <div v-if="item.offer.organization">
            Rede:
            <organization-info :organization="item.offer.organization" />
          </div>
        </td>
        <td>
          <small>{{invoiceIssuer(item.offer.invoice_issuer)}}</small>
        </td>
        <td class="text-center">{{item.price | moeda}}</td>
        <td class="text-center">
          <span v-if="isEdittingItems">
            <b-form-input number :formatter="itemEditorFormater(item)" type="number" :max="item.offer.qtd - item.offer.qtd_ordered" v-model="item.qtd" />
            <small>Quantidade restante na oferta: {{ item.offer.qtd - item.offer.qtd_ordered }}</small>
          </span>
          <span v-else>{{ item.qtd }}</span>
        </td>
        <td>{{item.price * item.qtd | moeda}}</td>
        <td>
          <b-form-select v-if="isSupplier" :class="'form-control select-status ' + item.status" v-model="item.status" :options="status_do_item" @input="changeStatus()" />
          <span v-else>{{ status_do_item.find(status => status.value == item.status).text }}</span>
        </td>
      </tr>
    </tbody>
  </table>
  <div v-if="isLink">
    <br>
    <div class="text-right">
      <Button class="btn btn-default" @click="saveItemsChange" v-if="isEdittingItems">Concluir alteração</Button>
      <Button class="btn btn-default" @click="isEdittingItems = true" v-else>Editar items</Button>
    </div>
    <div v-if="isEdittingItems">
      <b-form-group label="Adicione outros produtos a esse pedido">
        <form-entity-select type="offers" label="Selecione a oferta" :form="form" :input="addItem" field="newItem" :itemsToExclude="order.items" clearAfterSelect="True" />
      </b-form-group>
    </div>
  </div>
  <br>
  <div class="text-right">
    <div v-if="order.shipping_price && order.shipping_price > 0">
      <small>Pedido: {{getTotal() | moeda}}</small>
      <br />
      <small>Frete: {{order.shipping_price | moeda}}</small>
      <h4>
        <strong>Total: {{getTotal() + order.shipping_price | moeda}}</strong>
      </h4>
    </div>
    <h4 v-else>
      <strong>Total: {{getTotal() | moeda}}</strong>
    </h4>
    <div v-if="isManager">
      <div v-if="show_shipping_form">
        <b-form-group label="Valor do frete">
          <money v-model="shipping_price" class="form-control"></money>
          <a class="btn btn-default btn-sm" @click="saveShippingPrice">Salvar frete</a>
        </b-form-group>
      </div>
      <div v-else>
        <a class="btn btn-default btn-sm" @click="show_shipping_form = true" v-if="!order.shipping_price || order.shipping_price == 0">Adicionar frete</a>
        <a class="btn btn-default btn-sm" @click="show_shipping_form = true" v-else>Alterar frete</a>
      </div>
    </div>
  </div>
  <div v-if="isSupplier">
    <h3>Boletos</h3>
    <order-invoices :order="order" :totalValue="Number(getTotal()) + Number(order.shipping_price || 0)" />
  </div>
  <div>
    <dorothy-community
      :id="chatCode"
      :description="dorothy"
    ></dorothy-community>
  </div>
</div>
</template>
<script>
import axios from "axios";
import ProductImage from "@/components/ProductImage";
import SupplierInfo from "@/components/SupplierInfo";
import OrganizationInfo from "@/components/OrganizationInfo";
import DocumentsUpload from "@/components/DocumentsUpload";
import OrderInvoices from "@/components/OrderInvoices";
import status_do_item from "@/data/status-do-item.json";
import FormEntitiesSelect from "@/components/FormEntitiesSelect";
import FormEntitySelect from "@/components/FormEntitySelect";

export default {
  name: "Order",
  data() {
    return {
      isEdittingItems: false,
      status_do_item: status_do_item,
      order: null,
      shipping_price: 0,
      show_shipping_form: false,
      form: {
        attachments: [],
        newItem: null,
      },
      invoices: [],
      dorothy: JSON.stringify({
        title: "Fale com o cliente pelo chat",
        tools: [
          {
            title: "Chat",
            element: "dorothy-workspace",
          },
        ],
        includes: [],
      }),
    };
  },
  computed: {
    chatCode() {
      if (process.env.NODE_ENV == "development") {
        return this.order.code;
      }
      return this.order.code + 10000;
    },
  },
  created() {
    this.fetchOrder();
  },
  destroyed() {
    this.$store.dispatch("setActiveOrder", null); // set active order for chat context
  },
  methods: {
    fetchOrder() {
      axios
        .get("orders/" + this.$route.params.id)
        .then((response) => {
          this.order = response.data;
          this.$store.dispatch("setActiveOrder", this.order); // set active order for chat context
          if (this.order && this.order.attachments) {
            this.form.attachments = this.order.attachments;
          }
          if (this.order && this.order.shipping_price) {
            this.shipping_price = this.order.shipping_price;
          }
        })
        .catch(this.showError);
    },
    getTotal() {
      return this.order.items
        .filter((i) => i.status != "canceled")
        .reduce(function (a, item) {
          return a + Number(item.total);
        }, 0);
    },
    changeStatus() {
      axios
        .put("orders/" + this.order._id, {
          items: this.order.items,
        })
        .then((response) => {
          if (response.data) {
            this.notify("Status atualizado com sucesso!");
          }
        })
        .catch((error) => {
          this.fetchOrder();
          this.showError(error);
        });
    },
    saveDocuments(form) {
      axios
        .put("orders/" + this.order._id, form)
        .then((response) => {
          if (response.data) {
            this.notify("Anexos salvos com sucesso!");
          }
        })
        .catch(this.showError);
    },
    setAddress(address) {
      axios
        .put("orders/" + this.order._id, {
          address,
        })
        .then((response) => {
          if (response.data) {
            this.order.address = response.data.address;
            this.notify("Endereço do pedido atualizado com sucesso!");
          }
        })
        .catch(this.showError);
    },
    saveRelatedOrganizations() {
      axios
        .put("orders/" + this.order._id, {
          relatedOrganizations: this.order.relatedOrganizations,
        })
        .then((response) => {
          if (response.data) {
            this.notify("Organização alterada com sucesso");
          }
        })
        .catch((error) => {
          this.fetchOrder();
          this.showError(error);
        });
    },
    addItem(newItem) {
      if (newItem.offer.qtd - newItem.offer.qtd_ordered > 0) {
        this.order.items.push({
          offer: newItem.offer,
          qtd: 1,
          price: newItem.offer.final_price,
          total: newItem.qtd * newItem.offer.final_price,
          status: "created",
        });

        this.form.newItem = null;
      } else {
        this.showError("Oferta sem estoque.");
        this.form.newItem = null;
      }
    },
    saveItemsChange() {
      var newItems = this.order.items.map((item) => {
        return {
          ...item,
          total: item.qtd * item.offer.final_price,
        };
      });
      this.order.items = newItems;
      axios
        .put("orders/" + this.order._id, {
          items: newItems,
        })
        .then((response) => {
          if (response.data) {
            this.notify("Items alterados com sucesso!");
          }
        })
        .catch((error) => {
          // Fetch valid data again if changes dont work, to restore state
          this.fetchOrder();
          this.showError(error);
        });
      this.isEdittingItems = false;
    },
    itemEditorFormater(item) {
      return (value) => {
        const remainingQtd = item.offer.qtd - item.offer.qtd_ordered;

        return value > remainingQtd ? remainingQtd : value;
      };
    },

    saveShippingPrice() {
      axios
        .put("orders/" + this.order._id, {
          shipping_price: this.shipping_price,
        })
        .then((response) => {
          if (response.data) {
            this.notify("Frete atualizado com sucesso");
            this.show_shipping_form = false;
            this.order.shipping_price = this.shipping_price;
          }
        })
        .catch(this.showError);
    },

    createMatrixRoom() {
      axios
        .post("orders/" + this.order._id + "/createMatrixRoom")
        .then((response) => {
          if (response.data) {
            this.order = response.data;
            this.notify("Chat criado com sucesso");
          }
        })
        .catch(this.showError);
    },
  },
  components: {
    ProductImage,
    SupplierInfo,
    OrganizationInfo,
    DocumentsUpload,
    OrderInvoices,
    FormEntitiesSelect,
    FormEntitySelect,
  },
};
</script>
